import { fromJS } from 'immutable';

export default {
    setFheTicket: (state, tickets) => {
        return state.setIn(['list'], fromJS(tickets)).set('initialized', true);
    },
    updateFheTicketState: (state, ticketId, ticketState) => {
        return state.setIn(['list', ticketId, 'state'], ticketState);
    },
    setFheTicketDetails: (state, ticketId, ticket) => {
        return state.setIn(['list', ticketId], fromJS(ticket));
    }
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/TicketFhe/core.js